import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';

export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () =>
            import("./features/auth/components/login/login")
                .then(m => m.LoginComponent)
    },
    {
        path: 'users',
        loadComponent: () =>
            import("./features/users/components/user-list/user-list")
                .then(m => m.UserList),
        canActivate: [authGuard, permissionGuard]
    },
    {
        path: 'notifications',
        loadComponent: () =>
            import("./features/notifications/components/notifications-list/notifications")
                .then(m => m.NotificationsList),
        canActivate: [authGuard, permissionGuard]
    },
    {
        path: 'metrics',
        loadComponent: () =>
            import("./features/metrics/components/metrics-list/metrics-list")
                .then(m => m.MetricsList),
        canActivate: [authGuard, permissionGuard]
    },
    {
        path: 'users/new',
        loadComponent: () =>
            import('./features/users/components/user-form/user-form')
                .then(m => m.UserForm),
        canActivate: [authGuard, permissionGuard]
    },
    {
        path: 'users/:id',
        loadComponent: () =>
            import('./features/users/components/user-detail/user-detail')
                .then(m => m.UserDetail),
        canActivate: [authGuard, permissionGuard]
    },
    {
        path: '',
        redirectTo: '/users',
        pathMatch: 'full'
    }
];